import React from 'react'
import './YellowStripTitleComponent.css'

const YellowStripTitleComponent = (props) => {
    return (
        <section className='YellowStripTitleComponent'>
            <div className='card'>
                <div>
                    <p className='card_text'>
                        {props?.heading}
                    </p>
                </div>
            </div>
        </section>
    )
}

export default YellowStripTitleComponent
